module.exports = __webpack_public_path__ + "img/vipyj@2x.2445ee0a.png";